module.exports = __webpack_public_path__ + "static/media/dominica.acb2bc7c.jpg";